/*
 * Selector for the employee-commute workforce breakdown saved on the application
 */

import { createSelector } from 'reselect';

import getApplicationSelector from './getApplicationSelector';

export default createSelector([getApplicationSelector], (application = null) => {
  const commuteFullTimePercent = application?.commuteFullTimePercent ?? null;
  const commuteWorkdaysFullTime = application?.commuteWorkdaysFullTime ?? null;
  const commuteWorkdaysPartTime = application?.commuteWorkdaysPartTime ?? null;
  return {
    commuteFullTimePercent,
    commuteWorkdaysFullTime,
    commuteWorkdaysPartTime,
    hasCommuteWorkforce:
      commuteFullTimePercent !== null && commuteWorkdaysFullTime !== null && commuteWorkdaysPartTime !== null,
  };
});
